<template>

<app-content-box title="Participants" icon="users" :transparent="true" :not-padded="true" v-if="collection.length">

	<app-content-filters-search v-model="filter.search" :is-inline="true" />

	<app-table :is-inline="true">

		<app-table-body>

			<app-table-row :layout="layout" :danger="isExcluded(item.id)" :success="awarded === item.id" v-for="item in collection" :key="item.id">

				<app-table-cell-badge :badge="item"/>
				
				<app-table-cell-action v-if="!awarded" :loading="is.awarding === item.id" :disabled="isExcluded(item.id) || is.awarding" icon="play" theme="blue" v-tooltip="'Award game to this participant'" v-on:click="onAwardClick(item.id)" />
				
				<app-table-cell-action v-if="!isExcluded(item.id) && !awarded" :loading="is.deleting === item.id" :disabled="is.deleting" icon="win.exclude" theme="red" v-tooltip="'Exclude player from eligibility'" v-on:click="onDeleteClick(item.id)" />
				
				<app-table-cell-action v-if="isExcluded(item.id) && !awarded" :loading="is.restoring === item.id" :disabled="is.restoring" icon="win.include" theme="red" v-tooltip="'Restore player eligibility'" v-on:click="onRestoreClick(item.id)" />

            </app-table-row>    

		</app-table-body>

	</app-table>

</app-content-box>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

    props: ['count', 'win', 'awarded', 'excluded'],

	data: function() {

		return {
			pagination: {
				perpage: 100000
			},
            is: {
				awarding: false,
                deleting: false,
				restoring: false
            },
			endpoint: 'convention/checkout/win/:id/participants',
			live: 'convention/checkout/win/:id/participants'
		}

	},

    watch: {
    
        count: function() {
        
            this.load(true)
        
        }

    },

	computed: {
	
		layout: function() {
		
			return (this.awarded) ? 'auto' : 'auto 24px 24px'
		
		}

	},

    methods: {

		isExcluded: function(id) {

			return this.$_.contains(this.excluded, id)

		},

        afterLoad: function() {

			if(this.is.deleting) {
			
				this.$notify({
					message: 'Participant excluded successfully.'
				})
			
				this.is.deleting = false
			
			} else if(this.is.restoring) {
			
				this.$notify({
					message: 'Participant restored successfully.'
				})
			
				this.is.restoring = false
			
			}

        },

		onAwardClick: function(id) {
		
			this.is.awarding = id

		},

		onRestoreClick: function(id) {
		
            this.is.restoring = id

            this.$api.post(['convention/checkout/win', this.win, 'participants'], {
				id: id
			}).then(function() {

				this.$emit('changed')

			}.bind(this), function() {

				this.$notify({
					type: 'error',
					message: 'Sorry, participant could not be restored.'
				})

				this.is.restoring = false
			
			}.bind(this))

		},
    
        onDeleteClick: function(id) {
        
            this.is.deleting = id

            this.$api.delete(['convention/checkout/win', this.win, 'participants', id]).then(function() {

				this.$emit('changed')

			}.bind(this), function() {

				this.$notify({
					type: 'error',
					message: 'Sorry, participant could not be excluded.'
				})

				this.is.deleting = false
			
			}.bind(this))
        
        }
    
    }

}

</script>

<style scoped>

</style>